export const IMGIX_RE = /^https:\/\/[\w_-]+\.imgix\.net\//;
export const IMAGINARY_RE = /^https:\/\/imaginary\.governorhub\.com\/[\w_-]+$/;
export const GRAVATAR_RE = /^https?:\/\/www\.gravatar\.com\//;
